export default __webpack_public_path__ + "static/ad-68284282e903427a6e75d94f9f9a0a59.svg";